export class Storage {
	private userId = '';
	private storage: {[key: string]: any};

	constructor(userId = '') {
		this.userId = userId;

		try {
			this.storage = window.localStorage;
		} catch (error) {
			this.storage = {};
		}
	}

	getExpandedKey(key: string) {
		return `${this.userId || ''}:feedback:${key}`;
	}

	set(key: string, value: any) {
		const _key = this.getExpandedKey(key);

		try {
			this.storage[_key] = JSON.stringify(value);
		} catch (err) {
			// asi es la vida
		}
	}

	get(key: string) {
		const _key = this.getExpandedKey(key);

		try {
			return JSON.parse(this.storage[_key]);
		} catch (err) {
			return null;
		}
	}
}

export function createStorage(userId = '') {
	return new Storage(userId);
}
